import LearningPathFormStepper from "@/components/forms/learningPath/LearningPathFormStepper"
import { ScopedLearningPathFormStepper } from "@/components/forms/learningPath/LearningPathStepperDefinition"
import ScreenWrapper from "@/components/ScreenWrapper"
import { learningPathSchema } from "@/schemas/learningPath/learningPathCreateSchema"
import { useLearningPathCreateStore } from "@/stores/useLearningPathCreateStore"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"
import { useMemo } from "react"

export const Route = createFileRoute("/beheer/leerlijnen/aanmaken")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("create", "curriculum"),
})

function RouteComponent() {
  const { learningPathStepData, moduleStepData } = useLearningPathCreateStore()
  const initialStep = useMemo(() => {
    const learningPathStepDataIsValid =
      learningPathSchema.safeParse(learningPathStepData)
    if (learningPathStepDataIsValid.success && !moduleStepData) {
      return "module"
    }

    return "learningPath"
  }, [learningPathStepData, moduleStepData])

  return (
    <ScreenWrapper className="mt-8" showManagementMenu>
      <div className="flex w-full">
        <div className="flex flex-col justify-center h-full w-full">
          <ScopedLearningPathFormStepper initialStep={initialStep}>
            <LearningPathFormStepper />
          </ScopedLearningPathFormStepper>
        </div>
      </div>
    </ScreenWrapper>
  )
}
